import React, { useState, useEffect } from "react";
import URI from "urijs";
import Cookies from "js-cookie";

export default function Maintenance ({ config, children }) {
  const cookieName = `maintenancePassword-${config.id}`;
  const isFromBackoffice = (new URI(window.location.href).search(true).from) === "backoffice";
  const previewPassword = new URI(window.location.href).search(true).preview;
  const [input, setInput] = useState("");
  const passwordFromCookies = Cookies.get(cookieName);
  const [unlocked, setUnlocked] = useState(!config.getProperty("information", "maintenanceMode"));
  const [phrase] = useState(config.getProperty("information", "maintenanceModeNotice") || "Coming soon...");

  const comparePwd = pwd => {
    return pwd === config.getProperty("information", "maintenancePassword");
  };

  useEffect(() => {
    if (!unlocked) {
      if ((previewPassword && (comparePwd(previewPassword))) || isFromBackoffice) {
        Cookies.set(cookieName, previewPassword, { expires: 365 });
        setUnlocked(true);
      } else if (passwordFromCookies && (comparePwd(passwordFromCookies)))
        setUnlocked(true);
    }
  }, [config, previewPassword, passwordFromCookies]);

  const handleSubmitMaintenancePassword = e => {
    e.preventDefault();
    if (comparePwd(input)) {
      setUnlocked(true);
      Cookies.set(cookieName, input, { expires: 365 });
    }
  };

  if (unlocked) return children;
  else
    return (
      <div id="maintenance">
        <h1>{config.getProperty("information", "shopName")}</h1>
        <p>{phrase}</p>
        <form id="login" onSubmit={handleSubmitMaintenancePassword}>
          <label>
            Have a preview password?
            <input type="password" name="password" onChange={e => setInput(e.target.value)} required placeholder="Enter password..." />
          </label>
        </form>
      </div>
    );
}
